module.exports = __webpack_public_path__ + "img/10.06e886d9.png";